import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const HanaResult = () => {
  return <CommonResult />;
};

export default HanaResult;
